/**
 * Bundled expand/collapse section SFX (`assets/Sounds/ui-section-*.mp3`). CC0 previews from Freesound — see `assets/Sounds/THIRD_PARTY.txt`.
 */

import {
  resolveBundledMp3NativeSource,
  resolveBundledMp3UriForWeb,
} from './bundledMp3Module.helper';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const SECTION_EXPAND_MODULE = require('../../../assets/Sounds/ui-section-expand.mp3') as unknown;
// eslint-disable-next-line @typescript-eslint/no-require-imports
const SECTION_COLLAPSE_MODULE = require('../../../assets/Sounds/ui-section-collapse.mp3') as unknown;

export function getNativeSectionExpandSource(): number | { uri: string } | null {
  return resolveBundledMp3NativeSource(SECTION_EXPAND_MODULE);
}

export function getNativeSectionCollapseSource(): number | { uri: string } | null {
  return resolveBundledMp3NativeSource(SECTION_COLLAPSE_MODULE);
}

export function getSectionExpandBundledUriForWeb(): string | null {
  return resolveBundledMp3UriForWeb(SECTION_EXPAND_MODULE);
}

export function getSectionCollapseBundledUriForWeb(): string | null {
  return resolveBundledMp3UriForWeb(SECTION_COLLAPSE_MODULE);
}
